import { configureStore } from '@reduxjs/toolkit';
import dialogsReduce from './dialog-reduce.ts';
import profileReduce from './profile-reduce.ts';
import saitbarReducer from './saitbar-reduce.js';
import usersReducer from './users-reducer.ts';
import musicReducer from './music-reducer.js';
import authReducer from './auth-reducer.ts';
import { reducer as formReducer } from 'redux-form';
import appReducer from './app-reducer.ts';

const store = configureStore({
    reducer: {
  profilePage: profileReduce,
  dialogMessagePage: dialogsReduce,
  navBarFreands: saitbarReducer,
  usersPage: usersReducer,
  musicPage: musicReducer,
  auth: authReducer,
  form: formReducer,
  app: appReducer,
}
});

export type RootState = ReturnType<typeof store.getState>

type PropertiesTypes<T> = T extends {[key: string]: infer U } ? U : never
export type InferActionTypes<T extends {[key: string]: (...args: any[]) => any}> = ReturnType<PropertiesTypes<T>>

// @ts-ignore
window.store = store;


export default store;